import React from "react";

export default function AppFormikTextareaInline(props) {
    const {
        formik,
        stFormClass,
        textareaRows,
        textareaCols,
        labelName,
        isRequired,
        placeholder,
        formikFieldName,
    } = props;

    return (
        <div
            className={`st-form ${stFormClass || ""} ${formik.touched[formikFieldName] &&
                formik.errors[formikFieldName]
                ? "has-msg msg-error"
                : ""
                }`}
        >
            {labelName ? (
                <label>
                    {labelName}
                    {isRequired && <span className="required ms-1 st-fs-12">(required)</span>}
                </label>
            ) : null}
            <div className="media-body st-form-input-container">
                <textarea
                    type="text"
                    className="form-control"
                    cols={textareaCols ?? ""}
                    rows={textareaRows ?? ""}
                    placeholder={placeholder}
                    id={formikFieldName}
                    {...formik.getFieldProps(formikFieldName)}>
                </textarea>
                {
                    /* form message */
                    formik.touched[formikFieldName] && formik.errors[formikFieldName] && (
                        <div className="st-form-msg position-absolute">
                            <p className="st-fs-12">
                                {formik.errors[formikFieldName]}
                            </p>
                        </div>
                    )
                }
            </div>
        </div>
    );
}
